import { all, call, put, race, select, take, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import config from '../../../../../../../../../../../config'
import { LOAD_REALESTATES_ESTATES_OWNERSHIP_DATA_TABLE, DATA_TABLE_REQUEST } from './constants'

import { loadDataTableRequest } from './actions'
import { blockSaveCustomData } from '../../../../../../../../../components/Workspace/components/HocBlock/actions'

import { localeSelector, tokenSelector, customDataSelector } from './selectors'

import ownershipListDetailSaga from './components/OwnershipListDetail/saga'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function* loadDataTable(id, page = 0, rowsPerPage = 10, sorting = []) {
    const token = yield select(tokenSelector, id)
    if (!token) return null

    let customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipList: {
                ..._.get(customData, 'ownershipList', {}),
                isLoading: true,
            },
        })
    )

    const locale = yield select(localeSelector)
    const sortQsParam = _.join(
        _.map(sorting, (sort) => `${sort.id}:${sort.desc ? 'desc' : 'asc'}`),
        ','
    )

    const result = yield all({
        response: race({
            success: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY)}_${SUCCESS}`),
            failed: take(`${DATA_TABLE_REQUEST(MODULE_KEY, id, BLOCK_KEY)}_${FAILED}`),
        }),
        request: put(
            loadDataTableRequest(MODULE_KEY, id, BLOCK_KEY, {
                lang: locale,
                'sort[]': sortQsParam,
                rows: rowsPerPage,
                page,
                token,
            })
        ),
    })

    const data = _.get(result, 'response.success.payload.response.body', null)
    if (result.response.failed || !data) return null

    customData = yield select(customDataSelector, id)

    yield put(
        blockSaveCustomData(MODULE_KEY, id, BLOCK_KEY, {
            ownershipList: {
                ..._.get(customData, 'ownershipList', {}),
                isLoading: false,
                isLoaded: true,
                estatesWithImportantRestrictions: _.get(data, 'estatesWithImportantRestrictions', 0),
                table: {
                    data: _.get(data, 'listOfOwnerships', []),
                    pagination: _.get(data, 'query.pagination', {}),
                    sort: {
                        availableColumns: _.get(data, 'query.sort.availableColumns', []),
                        sorted: _.map(_.get(data, 'query.sort.sortedColumns', []), (sort) => ({
                            id: sort.columm,
                            desc: sort.direction === 'desc',
                        })),
                    },
                },
            },
        })
    )

    return null
}

function* onLoadDataTable(_action) {
    const id = _.get(_action, 'data.id', null)
    if (!id) return null

    const page = _.get(_action, 'data.page', 0)
    const rowsPerPage = _.get(_action, 'data.rowsPerPage', 10)
    const sorting = _.get(_action, 'data.sorting', [])

    yield call(loadDataTable, id, page, rowsPerPage, sorting)

    return null
}

export default function* blockTransformSaga() {
    yield all([takeEvery(LOAD_REALESTATES_ESTATES_OWNERSHIP_DATA_TABLE, onLoadDataTable), ownershipListDetailSaga()])
}
